import { decodeJwtPayload } from '@auth';

export const getOktaId = (token: string | null): string => {
  if (!token) throw new Error('No access token available');
  const payload = decodeJwtPayload(token);
  const uid = payload?.['uid'];

  if (typeof uid !== 'string') throw new Error('Token has no uid claim');

  return uid;
};
